import React, { useState } from 'react';
import { formatValue } from '../../base/common/utils';
import { ordersService } from './orders-service';

import { Loader } from '../../misc/loader-utils';
import Product from './product';

const PRODUCTS_SHOWING = 4;

const ProductsSubcard = ({ data, showLoadingSpinner }) => {
  const [showLess, setShowLess] = useState(true);
  const products = data.event_products;

  const productItems =
    products && products.map((product, index) => <Product data={product} key={index} />);

  const showingProducts =
    products && showLess ? productItems.slice(0, PRODUCTS_SHOWING) : productItems;

  const showLessButton =
    products && products.length > PRODUCTS_SHOWING ? (
      <button className="show-less" onClick={() => setShowLess(!showLess)}>
        Show {showLess ? 'More' : 'Less'}
      </button>
    ) : null;

  const orderText = products
    ? `Placed an order for ${products.length} product${products.length === 1 ? '' : 's'} (
    ${formatValue(data.checkout_value_usd, 'currency')}
    )`
    : null;

  const checkoutTime = products ? ordersService.format(data.datetime_attributed_checkout) : null;

  return (
    <div className="products-subcard">
      <div className="order-info">
        <span className="placed-order">{orderText} </span>
        <span className="checkout-datetime">{checkoutTime}</span>
      </div>
      <div className="products">
        {showingProducts}
        <Loader loading={showLoadingSpinner} />
      </div>
      <div className="controls">{showLessButton}</div>
    </div>
  );
};

export default ProductsSubcard;
